import { createFileRoute } from '@tanstack/react-router';
import SignalEntityPage from '@/pages/SignalEntityPage.jsx';
import { SignalsError, SignalsPending } from '@/components/signals/SignalBits.jsx';
import { getSignalEntity } from '@/api';

function OrganizationRoute() {
  const prof = Route.useLoaderData();
  return <SignalEntityPage prof={prof} />;
}

export const Route = createFileRoute('/organizations/$id')({
  loader: ({ params }) => getSignalEntity('org', params.id),
  component: OrganizationRoute,
  pendingComponent: SignalsPending,
  pendingMs: 200,
  errorComponent: ({ error }) => <SignalsError title="Couldn’t load this organization" error={error} />,
});
